<template>
  <div>
    <span class="fw-700">Space Rented</span>
    <!--  @click="testCron" -->
    <div class="ts-14 my-2">
      Select your rented collaterals to see the audit space.
    </div>
    <div class="row" id="scrollTarget0">
      <div class="col-md-4 col-sm-6 grid-item h-100 mb-3" :key="index" v-for="(space, index) in auditStoreInfoSpaceRented">
        <button @click="testaudit()" style="display: none;">test</button>
        <div class="c-pointer" @click="loadSpaceInformation(space.campaignDtlId)" :class="[space.campaignDtlId == selectedcampaignDtlId?'active-space-rented':'space-rented-item']">
          <p class="text-capitalize m-0">{{ space.type }}</p>
          <small class="m-0 ts-10">{{ space.dimension }}</small><br>
          <small class="text-capitalize m-0 ts-10">{{ space.placement }}</small><br>
          <small class="text-capitalize m-0 ts-10 text-danger" 
            v-if="(space.auditStatus == null && auditTimeline.length > 0) || 
            (hasOwnProperty(space,'cancelled') && space.cancelled.status =='denied' && space.auditStatus == null)"
            ><i class="mdi mdi-alert-circle"></i>Action Needed</small>
          <small class="text-capitalize m-0 ts-10" v-else> &nbsp; </small>
        </div>
      </div>
    </div>
    
    <div v-if="auditTimeline.length > 0"> 
      <b-tabs content-class="mt-3 pt-3 text-muted" nav-class="nav-tabs-custom">
        <b-tab :active="true">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">Audit Space</span>
          </template>
        </b-tab>
      </b-tabs>
      <div class="d-flex align-items-center justify-content-center" v-if="displayPrompt == 'd'">
        <span class="float-start me-2 ts-30 text-danger reverse-y">
          <i class="bx bx-info-circle"></i>
        </span>
        <span class="ts-10">
          You have 5 days to confirm or make an action otherwise the payment will be automatically released.
        </span>
      </div>
      <div class="d-flex align-items-center justify-content-center" v-if="displayPrompt == 's'">
        <span class="float-start me-2 ts-30 text-success">
          <i class="bx bx-check-circle"></i>
        </span>
        <span class="ts-10">
          You've successfully shipped your collaterals. Now, please wait for an update regarding the delivery of the collaterals to the store.
        </span>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="p-4">
            <div class="verti-timeline left-timeline">
              <div
                v-for="(item, index) in auditTimeline"
                :key="index"
                :class="`timeline-item`"
              >
                <!-- v-bind:id="'scrollTarget'+index" -->
                <div class="timeline-block" v-if="item.divType == 'checkpoint'">
                  <div class="timeline-box card" :class="{'timeline-active':item.paymentStatus == null && !['onHold','cancelled'].includes(item.auditStatus) && ((index+1) != auditTimeline.length || collateralStatusChecker(item.collateralStatus))}">
                    <div class="card-body row" :class="[index > 0 ? 'sold-item-op':'']">
                      <div class="col-md-7 col-sm-12">
                        <div class="timeline-date text-dark fw-bold">{{ item.date | formatDate}}</div>
                        <h5 class="mt-3 font-size-16 text-capitalize">{{ item.title }}</h5>
                        <div class="text-muted">
                          <p class="mb-0">Collateral Status: {{item.collateralStatus}}</p>
                          <p class="mb-0">Payment Status: {{item.paymentStatus == null ? "--":item.paymentStatus}}</p>
                          <p class="mb-0">Fund Released: ₱ {{item.fundRelease == null ? 0 : item.fundRelease | toCurreny}}</p>
                          <div v-if="true">
                            <!-- collateralStatusChecker(item.collateralStatus) -->
                            <button type="button" class="view-report-css mt-4" v-if="['onHold','approved','cancelled'].includes(item.auditStatus)" @click="openModal('bv-modal-view-action');viewAction = item">
                              View Report
                            </button>
                            <button type="button" class="btn btn-primary mt-2 position-relative" @click="openModal('bv-modal-action');actionFormId=item.auditDtlId;actionBtnIndex=index" :disabled="index > 0"
                            v-if="item.paymentStatus == null && !['onHold','cancelled'].includes(item.auditStatus) && ((index+1) != auditTimeline.length || collateralStatusChecker(item.collateralStatus))">
                              View Action
                              <span class="position-absolute top-0 start-100 translate-middle reverse-y">
                                <i class="bx bx-info-circle reverse-y bg-danger rounded-pill"></i>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5 col-sm-12" v-if="item.images && dateChecker(item.imgUploadedAt)">
                        <div class="timeline-date my-3 ts-13 text-dark fw-bold">Date Uploaded: {{ item.imgUploadedAt | formatDate}}</div>
                        <a
                          href="javascript:void(0);"
                          v-for="(image, index) in item.images"
                          :key="index"
                        >
                          <img :src="`${image}`" alt="" class="rounded" style="height: 100px;"
                          @error="
                            (e) =>
                              (e.target.src = require('@/assets/images/img-placeholder.png'))
                          "/>
                        </a>
                      </div>
                      <!-- <div class="col-12 ts-12 mt-3" v-if="hasOwnProperty(item,'cancellationInfo')">
                        <span class="text-danger"><i class="mdi mdi-alert-circle me-1"></i> Remarks:</span> Your cancellation request has been declined as it 
                        does not meet the necessary criteria. If you have any questions or concerns please <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a>
                      </div> -->
                      <div class="col-12 ts-12 mt-3" v-if="item.actionBy == 'system' && item.actionDesc == 'Autorelease Payment'">
                        <span class="text-danger"><i class="mdi mdi-alert-circle me-1"></i> Remarks:</span> Please note that we have automatically released your funds to the store
                        owner due to failure to respond to required action. If you have any questions or 
                        concerns please <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="timeline-block" v-else>
                  <div class="timeline-box card" :class="{'timeline-active':index == 0 && item.cancelReqStatus == 'denied'}">
                    <div class="card-body row" :class="[index > 0 ? 'sold-item-op':'']">
                      <div class="col-12">
                        <div class="timeline-date text-dark fw-bold">{{ item.date | formatDate}}</div>
                        <h5 class="mt-3 mb-3 font-size-16 text-capitalize">{{ item.title }}</h5>
                        <div v-if="item.cancelReqStatus == 'pending'">
                          <p class="ts-12">
                            <span class="text-warning"><i class="mdi mdi-alert-circle me-1"></i> Remarks:</span> Your cancellation request is being processed, 
                            kindly wait for your cancellation status. If you have any questions or concerns please 
                            <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a>
                          </p>
                        </div>
                        <div v-if="item.cancelReqStatus == 'accepted'">
                          <div class="text-muted mb-2">
                            <p class="mb-0">Amount Deducted: ₱ {{item.amountDeducted | toCurreny}}</p>
                            <p class="mb-0">Amount Released: ₱ {{item.amountReleased | toCurreny}}</p>
                          </div>
                          <p class="ts-12">
                            <span class="text-success"><i class="mdi mdi-check-circle me-1"></i> Remarks:</span> Your store rental for {{acceptedCancelTarpPlacement}} 
                            has been successfully approved. If you have any questions or concerns please Contact Support
                            <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a>
                          </p>
                        </div>
                        <div v-if="item.cancelReqStatus == 'denied'">
                          <p class="ts-12">
                            <span class="text-danger"><i class="mdi mdi-close-circle-outline me-1"></i> Remarks:</span> Your cancellation request has been denied as it 
                            does not meet the necessary criteria. If you have any questions or concerns please
                            <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a>
                          </p>
                          <button type="button" class="btn btn-primary mt-2 position-relative" 
                            v-if="item.auditStatus == null && index == 0"
                            @click="openModal('bv-modal-action');actionFormId=item.auditDtlId;actionBtnIndex=index;form.type='cancel'">
                            View Action
                            <span class="position-absolute top-0 start-100 translate-middle reverse-y">
                              <i class="bx bx-info-circle reverse-y bg-danger rounded-pill"></i>
                            </span>
                          </button>
                          <button type="button" class="view-report-css mt-4" v-else @click="openModal('bv-modal-view-action');viewAction = item">
                            View Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="bv-modal-action" title="action form" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-action')"><i class="bx bx-x"></i></span>
        <h5>What action do you want to take for this collateral?</h5>
        <p class="ts-11 m-0" v-if="form.type == 'cancel'">
          Your initial request to cancel does not fit within the guidelines, please choose the remaining options below or please 
          <a href="#" onclick="FB.CustomerChat.showDialog()">Contact Support</a> to ask for assistance.
        </p>
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form
            ref="collateralSetupForm"
            @submit.prevent="handleSubmit(submitActionForm)"
            @reset.prevent="reset"
          >
            <b-form-group class="mt-4 ts-14">
              <label>Please choose an action in the dropdown below <span class="text-danger">*</span></label>
              <validation-provider
                name="choose action"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-select
                  v-model="form.action"
                  :options="actionOption"
                  class="form-select mb-3 shadow-none"
                  :state="getValidationState(validationContext)"
                >
                </b-form-select>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group class="mt-4 ts-14" v-if="form.action !=null">
              <label>
                Description <span class="text-danger">*</span> 
                <small class="text-muted">({{ form.max - (form.description == null ? 0 : form.description.length) }})</small>
              </label>
              <validation-provider
                name="description"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="form.description"
                  placeholder="Enter description"
                  :state="getValidationState(validationContext)"
                  rows="3"
                  max-rows="6"
                  maxlength="250"
                ></b-form-textarea>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <div class="mt-2">
              <b-button
                class="float-end"
                type="submit"
                variant="primary"
                :disabled="isSubmitted"
              >
                <span
                  v-if="isSubmitted"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submit
              </b-button>
              <b-button
                class="float-end me-2"
                type="button"
                variant="secondary"
                @click="closeModal('bv-modal-action')"
              >
                close
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
      </b-modal>
      <b-modal id="bv-modal-view-action" title="View action" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-view-action')"><i class="bx bx-x"></i></span>
        <h5>What action do you want to take for this collateral?</h5>
        <div class="row p-2 mt-4">
          <div class="col-12 mt-2">
            <p class="mb-4">
              <span class="me-2">Please choose an action in the dropdown below:</span>
              <b-form-select
                  v-model="viewAction.auditStatus"
                  :options="actionOption"
                  class="form-select mb-3 shadow-none"
                  disabled
                >
              </b-form-select>
            </p>
            <p class="mb-4" style="word-wrap: break-word;">
              <span class="me-2">Description:</span><br>
                <b-form-textarea
                  id="textarea"
                  v-model="viewAction.actionDesc"
                  placeholder="Enter description"
                  rows="3"
                  max-rows="6"
                  maxlength="250"
                  disabled
                ></b-form-textarea>
            </p>
            <p class="mb-4">
              <span class="me-2">Action by:</span>
              <span class="fw-semibold">{{viewActionBy}}</span>
            </p>
          </div>
        </div>
      </b-modal>
      <b-modal id="bv-modal-confirmation" title="confirmation" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-confirmation')"><i class="bx bx-x"></i></span>
        <div class="row p-2 mt-4">
          <div class="col-12 d-flex align-items-center justify-content-center my-3 text-primary">
            <i style="font-size: 50px;" class="bx bx-info-circle"></i>
          </div>
          <div class="col-12 text-center">
            <p style="font-family: Poppins;
              font-size: 24px;
              font-weight: 500;
              ">Are you sure?</p>
          </div>
          <div class="col-12 mt-2">
            <p class="mb-0 text-center">
              <span v-if="form.action == 'onHold'">
                Please note, you are required to resend marketing collaterals to the store. The contract will resume once the new collaterals reach the store.
              </span>
              <span v-if="form.action == 'cancelled'">
                Once confirmed, your request will be processed. Please note that if your cancellation request is deemed appropriate, 
                no cancellation fee will be deducted from your total holding balance.
                <!-- Once confirmed, your request will be processed. Please note that once your cancellation request is approved, 
                a cancellation fee of <span class="text-danger">10%</span> will be deducted from your total holding balance. -->
              </span>
              <span v-if="form.action == 'force-cancelled'">
                Please note that a total of ₱{{ monthlyRate * 2 }} from {{currentMonth}} & {{NextMonth}} will be deducted to your 
                holding balance as your previous request to cancel did not fit the appropriate guidelines.
              </span>
            </p>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-center my-3">
            <b-button
              class="me-2 px-4"
              type="button"
              variant="secondary"
              @click="closeModal('bv-modal-confirmation')"
            >
              No
            </b-button>
            <b-button
              class="me-2 px-4"
              type="button"
              variant="primary"
              :disabled="isSubmitted"
              @click="onHoldConfirmation = true;submitActionForm();"
            >
              <span
                v-if="isSubmitted"
                class="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Yes
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {auditSpaceComputed,auditSpaceMethods,walletMethods } from "@/state/helpers";
import moment from "moment";

export default {
  props: ["value"],
  data() {
    return {
      selectedcampaignDtlId:0,
      isSubmitted:false,
      form:{
        action      :null,
        description :null,
        max         :250,
        type        :'checkpoint'
      },
      actionFormId:null,
      viewAction:{auditStatus:null,actionDesc:null},
      onHoldConfirmation:false,
      actionBtnIndex: null,
      viewDisplay:false,
      modalType:'view'
    };
  },
  computed: {
    ...auditSpaceComputed
  },
  methods: {
    ...auditSpaceMethods,
    ...walletMethods,
    async loadSpaceInformation(c_id){
      // this.$route.params.pid = c_id
      this.$router.push(
        {
          params: {pid: c_id}
        }
      )
      this.selectedcampaignDtlId = c_id
      await this.fetchTimeline();
      await this.fetchStoreSpaceInfo({"campaignDtlId":c_id});
    },
    async testaudit(){
      await this.fetchTimeline();
    },
    async fetchTimeline(){
      await this.fetchAuditSpaceLogs({"campaignDtlId":this.selectedcampaignDtlId})
      .then((res)=>{
        console.log("res fetchAuditSpaceLogs:: ",JSON.stringify(res))
      }).catch((err)=>{
        console.log("ERR fetchAuditSpaceLogs:: ",err)
      });
    },
    openModal(modal=''){
      this.modalType='view'
      if(modal === "bv-modal-action"){
        this.modalType='action'
        this.form.action = null;
        this.form.description = null;
      }
      //start enabled here
      // this.actionOption[3]["disabled"] = false;
      // if(this.actionBtnIndex+1 < this.auditTimeline.length){
      //   var last_checkpoint = this.auditTimeline[this.actionBtnIndex+1];
      //   if(Object.prototype.hasOwnProperty.call(last_checkpoint,"cancellationInfo")){
      //     if(last_checkpoint["cancellationInfo"]["status"] === "denied"){
      //       this.actionOption[3]["disabled"] = true;
      //     }
      //   }
      // }
      //enabled for testing

      this.$bvModal.show(modal);
    },
    closeModal(modal=''){
      this.$bvModal.hide(modal);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async submitActionForm(){
      var proceed=true;
      if(["onHold",'cancelled','force-cancelled'].includes(this.form.action) && !this.onHoldConfirmation){
        // this.onHoldConfirmation = true
        proceed = false;
        this.openModal("bv-modal-confirmation")
      }
      if(proceed){
        // console.log(">>>>> ",JSON.stringify(this.form));
        this.isSubmitted = true;

        await this.auditSpaceActionForm({...this.form,"campaignDtlId":this.selectedcampaignDtlId,"auditDtlId":this.actionFormId}).then((result)=>{
          console.log(result);
          this.isSubmitted = false;
          this.$toast.showToast(
            "success" , 
            "Success!" , 
            "Your action has been submitted.");
          this.closeModal('bv-modal-action');
          this.fetchStoreSpaceInfo({"campaignDtlId":this.selectedcampaignDtlId});
          this.fetchTimeline();
          this.fetchStoreInfo({"businessId":this.$route.params.id,"campaignHdrId":this.$route.params.chid});
        }).catch(()=>{
          setTimeout(() => {
            this.isSubmitted = false;
          }, 1500);
        });
        if(this.onHoldConfirmation){
          this.closeModal("bv-modal-confirmation")
        }
        this.onHoldConfirmation = false
        if(['cancelled','approved','force-cancelled'].includes(this.form.action) && !this.onHoldConfirmation){
            this.fetchWalletBalance();
            this.fetchHoldBalance();
        }
      }
    },
    collateralStatusChecker(status){
      return status === "Damaged" || status === "damaged" || status === "Good"
    },
    dateChecker(date){
      return moment(date).isValid()
    },
    hasOwnProperty(obj,prop){
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    testCron(){
      this.auditSpaceCronReleasePayment()
    },
    scrollToElement(target) {
      const elementToScrollTo = document.getElementById(target);
      elementToScrollTo.scrollIntoView({
          behavior: "smooth"
      });
      // const element = this.$refs[target];
      // element.scrollIntoView({ behavior: 'smooth' }); // Use smooth scrolling for a smooth transition
    },
  },
  async mounted(){
    var pid = this.$route.params.pid;
    // alert(this.$route.params.pid
    if(pid > 0 ){
      this.selectedcampaignDtlId = pid
    }else{
      this.selectedcampaignDtlId = this.auditStoreInfoSpaceRented[0]["campaignDtlId"];
    }
    await this.loadSpaceInformation(this.selectedcampaignDtlId);
    this.scrollToElement("scrollTarget0");
  },
  asyncComputed: {
    async viewActionBy() {
      var value = null
      try {
        value=this.viewAction.actionBy
      } catch (error) {
        console.log(">>>> err",error)
      }
      return value;
    },
    async displayPrompt() {
      var value = null,
          r = this.auditTimeline[0];
      if(r.auditStatus == null){
        value="d";
      }
      // try {
      //   var is_damaged = false;
      //   switch (this.auditTimeline[0]["collateralStatus"]) {
      //     case "Damaged":
      //         if(this.auditTimeline[0]["auditStatus"] != "approved"){
      //           value="d";
      //           is_damaged= true;
      //         }
      //       break;
        
      //     default:
      //       break;
      //   }
      //   //can't display this status
      //   if(this.auditShipStatus.auditStatus != null && this.auditShipStatus.courierName != null ){
      //         value="s"
      //   }
      //   if(this.auditShipStatus.trackingNumber != null && !is_damaged){
      //         value="x"
      //   }
      // } catch (error) {
      //   console.log(">>>> err",error)
      // }
      return value;
    },
    async actionOption() {
      var is_started_to_rent=0,
          checkpoints       =0,
          duration          =0;
      for(let s of this.auditStoreInfoSpaceRented){
        if(s.campaignDtlId == this.selectedcampaignDtlId){
          duration = s.duration
        }
      }
      for(let r of this.auditTimeline){
        if(["approved"].includes(r.auditStatus) && r.paymentStatus != null){
          is_started_to_rent++;
        }
        // console.log('++++++++++',JSON.stringify(r));
        if(r.auditStatus == "approved"){
          checkpoints++
        }
      }
      var value = [
        { value: null, text: 'Select Action', disabled: true },
        { value: is_started_to_rent== 0 ? "start":"approved", text: `Approved Current Condition - ${is_started_to_rent== 0?'Good':'Full Payment'}`},
        { value: "onHold", text: 'Resend Collateral - Hold Contract'},
        // { value: "cancelled", text: 'Collateral Unusable - Cancel Contract',disabled: true},//enabled for testing
      ]
      // checkpoints = 0
      if(duration > checkpoints || this.modalType == 'view'){ 
        value.push({ value: "onHold", text: 'Resend Collateral - Hold Contract'})
        if(this.form.type == "checkpoint"){
          value.push({ value: "cancelled", text: 'Collateral Unusable - Cancel Contract'})//enabled for testing
        }else{
          value.push({ value: "force-cancelled", html: 'Continue with Contract Cancellation <b style="color:maroon;">(includes cancellation fee)</b>'})//enabled for testing
        }
      }
      console.log("---------------",checkpoints, duration,this.modalType,'--------');
      // console.log("---------------",JSON.stringify(this.form),'--------');
      return value;
    },
    async acceptedCancelTarpPlacement() {
      var data=null;
      for(let r of this.auditStoreInfoSpaceRented){
        if(this.selectedcampaignDtlId == r.campaignDtlId){
          data = r.placement
        }
      }
      return data;
    },
    async monthlyRate() {
      var data=null;
      for(let r of this.auditStoreInfoSpaceRented){
        if(this.selectedcampaignDtlId == r.campaignDtlId){
          data = r.amount
        }
      }
      return data;
    },
    async currentMonth() {
      return moment().format('MMMM');
    },
    async NextMonth() {
      return moment().add(1, 'months').format('MMMM');
    },
  },
};
</script>

<style>
.space-rented-item{
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 10px;
}
.active-space-rented{
  border: 1px solid #F84B04;
  border-radius: 10px;
  padding: 10px;
}
.reverse-y{
  transform: scaley(-1);
}
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  width: 170px;
  background-color: #FFF;
  color: #000;
  text-align: center;
  border-radius: 4px;
  padding: 6px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border: 1px solid #ccc;
  box-shadow: 0px 3px 10px #CCC;
}

.tooltip-container-visible .tooltip {
  visibility: visible;
  opacity: 1;
}

.view-report-css{
  border: 0;
  background: none;
  color: #F84B04;
  text-decoration: underline;
}

.timeline-active{
  background: rgba(249,228,208, 0.5);
}
</style>

